import {ReactNode} from 'react';
import {ElementStatus, useFormElementContext} from '../../form';
import styles from './styles.module.less';
import {TooltipPlacement} from '../../tooltip';

type Props = {
	showOnError: 'required' | 'range' | 'email' | 'length-min' | 'length-max' | 'hex' | string;
	offsetX?: number;
	offsetY?: number;
	container?: HTMLElement | string;
	placement: TooltipPlacement;
	className?: string;
	arrowSize?: number;
	notHide?: boolean;
	show?: number;
	children?: ReactNode;
	absolute?: boolean;
	innerClassName?: string;
	showOnInit?: boolean;
};

export function FieldError(props: Props): JSX.Element {
	const context = useFormElementContext({}, FieldError);
	const error = context.firstError();
	if (error === props.showOnError && context.status !== ElementStatus.disabled) {
		return <div className={styles.fieldError} ref={context.ref} {...props}>{props.children}</div>;
	}
}
